/**
 * Mixin methods for the examples pages.
 *
 * @exports mixins
 * @category Views
 */

export default {
  components: {
    Story: () => import('@/views/examples/Layouts/Story'),
  },
  data: () => ({
    emits: [],
    formItems: [],
    propsModel: {},
    propDescription: {},
    slotsModel: {},
    slotDescription: {},
    slotFormItems: [],
  }),
  created() {
    this.formItems.forEach((formItem) => {
      formItem.forEach(({ defaultValue, props }) => {
        this.$set(this.propsModel, [props.prop], defaultValue);

        if (props.description) {
          this.$set(this.propDescription, [props.prop], props.description);
        }
      });
    });

    this.slotFormItems.forEach((formItem) => {
      formItem.forEach(({ defaultValue, props }) => {
        this.$set(this.slotsModel, [props.prop], defaultValue);

        if (props.description) {
          this.$set(this.slotDescription, [props.prop], props.description);
        }
      });
    });
  },
  methods: {
    /**
     * Updates the `payloads.emitted` object to the latest payload for display only purposes.
     *
     * @param {string} name
     * @param {object} payload
     */
    onEmit(name, payload) {
      this.emits.unshift({ name, payload });
    },
  },
};
